import { render, staticRenderFns } from "./VersionInfoSimple.vue?vue&type=template&id=f0dc104c&scoped=true"
import script from "./VersionInfoSimple.vue?vue&type=script&lang=js"
export * from "./VersionInfoSimple.vue?vue&type=script&lang=js"
import style0 from "./VersionInfoSimple.vue?vue&type=style&index=0&id=f0dc104c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0dc104c",
  null
  
)

export default component.exports